import React from 'react';

import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
        minWidth: '300px'
    },
})

class PopoverComponentLevel extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={this.props.open}
                anchorEl={this.props.anchorE1}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={this.props.onClose}
                disableRestoreFocus
            >
                <Typography>Name: {this.props.data[0]['name']}</Typography>
                <Divider />
                <Typography variant="subtitle2">Level Set Point</Typography>
                <Table size="small">
                    <TableBody>
                        <TableRow>
                            <TableCell style={{ width: '50%', borderBottom: 'none' }}>Alert: </TableCell>
                            <TableCell style={{ width: '50%', borderBottom: 'none' }}>{this.props.data[0]['value_1']}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ width: '50%', borderBottom: 'none' }}>Warning: </TableCell>
                            <TableCell style={{ width: '50%', borderBottom: 'none' }}>{this.props.data[0]['value_2']}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ width: '50%', borderBottom: 'none' }}>Danger: </TableCell>
                            <TableCell style={{ width: '50%', borderBottom: 'none' }}>{this.props.data[0]['value_3']}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Popover>
        )
    }
}

export default withStyles(styles, { withTheme: true })(PopoverComponentLevel);